import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { Link } from 'gatsby';

import { media, TransitionMixin } from '../helpers';
import Wrapper from '../elements/wrapper';

import Circles from '../../images/icons/hover-circles.inline.svg';
import Wave from '../../images/waves/home-top-wave.inline.svg';

const CollectionTilesContainer = styled.div`
    padding: 50px 0 100px;
    position: relative;

    .title-container {
        position: relative;
        text-align: center;
        ${media.medium`max-width: 78vw;text-align: left;`}

        h3 {
            font-family: neue-kabel, sans-serif;
            font-weight: 800;
            color: #000;
        }
    }

    .content-tiles-wrapper {
        display: flex;
        flex-wrap: wrap;
        ${media.medium`max-width: 80vw; margin-bottom: -15vh;`}
        ${media.laptop`  margin-bottom: -45vh;`}

        .item-container {
            flex: 0 0 50%;
            margin-bottom: 10px;
            ${media.small`flex: 0 0 25%; margin-bottom: 0px;`}

            > .inner-wrap {
                max-width: 90%;
                margin: 0 auto;

                a {
                    &:hover {
                        .image-container {
                            .hover-overlay {
                                opacity: 1;
                            }
                        }
                    }
                    .image-container {
                        position: relative;

                        .gatsby-image-wrapper {
                            /* ${media.medium`min-height: 345px;`} */
                        }

                        .overlay {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background-color: rgb(0, 0, 0, 0.4);
                            h4 {
                                color: #fff;
                                margin: 0;
                                font-size: 1.1rem;
                                text-align: center;
                            }
                        }

                        .hover-overlay {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            opacity: 0;
                            ${TransitionMixin('.25s')}

                            .small-svg {
                                svg {
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                    g {
                                        mask: none;
                                    }
                                }
                            }

                            .inner-wrap {
                                text-align: center;
                                padding: 0 20px;

                                h4 {
                                    color: #fff;
                                    font-size: 1.1rem;
                                    margin: 0 0 20px;
                                    ${media.medium`margin: 0 0 40px;`}
                                }

                                p {
                                    color: #fff;
                                    margin: 0 0 20px;
                                    font-size: 0.8rem;
                                    line-height: 1.3;
                                    ${media.medium`margin: 0 0 40px; font-size: .9rem;`}
                                    &.link {
                                        margin-bottom: 0px;

                                        font-weight: bold;
                                        border-bottom: 2px solid #fff;
                                        display: inline-block;
                                    }
                                }

                                .bottom-link {
                                    position: absolute;
                                    left: 0;
                                    bottom: 10px;
                                    width: 100%;
                                    ${media.medium`bottom: 30px;`}
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .bottom-wave-container {
        max-width: 100vw;
        background-color: #f2f0eb;
        padding-bottom: 15vh;
        margin-bottom: -15vh;

        .svg-container {
            background-color: #f2f0eb;

            svg {
                width: 100%;
                height: auto;
                path {
                    fill: #fff;
                    opacity: 1;
                }
            }
        }
        .wave-content {
            text-align: center;
            padding-top: 60px;
            ${media.small`padding-top: 0px;`}
            h3 {
                font-size: 3rem;
                color: #000;
                font-family: 'neue-kabel', sans-serif;
                margin: 0 0 15px;
                font-weight: 800;
                ${media.medium`font-size: 4rem;`}
            }

            p {
                font-size: 1.1rem;
                max-width: 550px;
                margin: 0 auto 30px;
                line-height: 1.5;
            }

            a {
                font-weight: bold;
                background-color: #f74c34;
                border: 1px solid #f74c34;
                color: #fff;
                text-decoration: none;
                border-radius: 5px;
                max-width: 225px;
                width: 100%;
                display: inline-block;
                padding: 15px 0;
            }
        }
    }
`;

const CollectionTiles = ({ contentTilesSettings, title, caption, button }) => {
    const { contentTiles } = contentTilesSettings || {};
    return (
        <CollectionTilesContainer>
            <Wrapper className="title-container">
                <h3>Purpose by design</h3>
            </Wrapper>
            <Wrapper className="content-tiles-wrapper">
                {contentTiles &&
                    contentTiles.map((tile) => {
                        const {
                            tileLink,
                            tileHoverColor,
                            tileShortDescription,
                            tileImage,
                        } = tile || {};
                        return (
                            <div className="item-container">
                                <div className="inner-wrap">
                                    <Link to={tileLink.url}>
                                        <div className="image-container">
                                            <Img
                                                fluid={
                                                    tileImage.localFile
                                                        .childImageSharp.fluid
                                                }
                                            />

                                            <div className="overlay">
                                                <h4>{tileLink.title}</h4>
                                            </div>
                                            <div
                                                className="hover-overlay"
                                                style={{
                                                    backgroundColor: tileHoverColor,
                                                }}
                                            >
                                                <div className="small-svg">
                                                    <Circles />
                                                </div>
                                                <div className="inner-wrap">
                                                    <h4>{tileLink.title}</h4>
                                                    <p>
                                                        {tileShortDescription}
                                                    </p>
                                                    <div className="bottom-link">
                                                        <p className="link">
                                                            Learn more
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        );
                    })}
            </Wrapper>
            <Wrapper className="bottom-wave-container">
                <div className="svg-container">
                    <Wave />
                </div>

                <Wrapper className="wave-content">
                    <h3>{title}</h3>
                    <p>{caption}</p>
                    <Link to={button.url}>{button.title}</Link>
                </Wrapper>
            </Wrapper>
        </CollectionTilesContainer>
    );
};

export default CollectionTiles;
